export enum TributeType {
    Both,
    InHonorOf,
    InMemoryOf,
}